import { render, staticRenderFns } from "./VIframe.vue?vue&type=template&id=7e5d3cd3&"
import script from "./VIframe.vue?vue&type=script&lang=js&"
export * from "./VIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports